import React from 'react'

import Visa from '@images/visa.png'

export default (props) =>
  <img {...props} src={Visa}></img>
